const getters = {
  getSearchParams: state => state.searchParams,
  getTriggeredReports: state => state.triggeredReports,
};

export default getters;
